@if (visible) {
  <div class="cookie-banner animate__animated animate__slideInUp">
    <div class="container py-3">
      @if (!detailedView) {
        <div class="d-flex flex-column flex-md-row align-items-center gap-3">
          <div class="flex-grow-1">
            <strong>Gestion des cookies</strong>
            <p class="mb-0 mt-1">
              Ce site utilise des cookies pour assurer son bon fonctionnement et améliorer votre expérience.
              <a routerLink="/cookies">En savoir plus</a>
            </p>
          </div>
          <div class="d-flex gap-2 flex-shrink-0">
            <button class="btn btn-outline-secondary btn-sm" (click)="refuseAll()">Tout refuser</button>
            <button class="btn btn-link btn-sm" (click)="showDetails()">Paramétrer</button>
            <button class="btn btn-primary btn-sm" (click)="acceptAll()">Tout accepter</button>
          </div>
        </div>
      } @else {
        <div>
          <strong>Paramétrer les cookies</strong>
          <div class="mt-3">
            <div class="form-check form-switch mb-2">
              <input class="form-check-input" id="cookieNecessary" type="checkbox" checked disabled />
              <label class="form-check-label" for="cookieNecessary">
                <strong>Strictement nécessaires</strong>
                — Authentification, mémorisation du consentement
              </label>
            </div>
            <div class="form-check form-switch mb-2">
              <input
                class="form-check-input"
                id="cookieAnalytics"
                type="checkbox"
                [checked]="analyticsChecked"
                (change)="analyticsChecked = !analyticsChecked"
              />
              <label class="form-check-label" for="cookieAnalytics">
                <strong>Analytics / Performance</strong>
                — Mesure d'audience, suivi d'erreurs
              </label>
            </div>
            <div class="form-check form-switch mb-2">
              <input
                class="form-check-input"
                id="cookieFunctional"
                type="checkbox"
                [checked]="functionalChecked"
                (change)="functionalChecked = !functionalChecked"
              />
              <label class="form-check-label" for="cookieFunctional">
                <strong>Fonctionnels</strong>
                — Préférences d'affichage
              </label>
            </div>
          </div>
          <div class="d-flex gap-2 mt-3 justify-content-end">
            <button class="btn btn-outline-secondary btn-sm" (click)="refuseAll()">Tout refuser</button>
            <button class="btn btn-primary btn-sm" (click)="saveChoices()">Enregistrer mes choix</button>
          </div>
        </div>
      }
    </div>
  </div>
}
